import { styled } from '@mui/material';

export const Spacer = styled('div')({
  flexGrow: 1,
});
